import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-ebony-clay py-10 lg:py-12">
      <div className="max-w-content mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">
          {/* Left: Logo + copyright + description */}
          <div className="flex-1">
            <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6 mb-4">
              <img
                className="w-[200px] lg:w-[273px] h-auto flex-shrink-0"
                src={require('../assets/img/footer/logo.png')}
                alt="Metalogix Logo"
              />
              <p className="font-proxima text-white text-base tracking-[0.8px] leading-normal">
                &copy; 2024 MetaLogix Solutions. All rights reserved.
              </p>
            </div>
            <p className="font-proxima-bold font-bold text-cadet-blue text-base tracking-[0.8px] leading-normal">
              <span>Premier Technology Consulting Firm<br /></span>
              <span className="font-proxima font-normal">
                Leveraging decades of&nbsp;&nbsp;experience to build high-quality, enterprise-grade solutions that&nbsp;&nbsp;accelerate digital transformation through AI-powered development.
              </span>
            </p>
          </div>

          {/* Right: Links + Contact */}
          <div className="flex gap-8 sm:gap-12 lg:gap-16">
            {/* Links */}
            <div>
              <h4 className="font-proxima-bold font-bold text-white text-xl tracking-[1px] leading-normal mb-4">
                Links
              </h4>
              <div className="space-y-2">
                <Link to="/about" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="block font-proxima text-periwinkle-gray text-base tracking-[0.8px] leading-normal hover:text-white transition-colors">About</Link>
                <Link to="/faq" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="block font-proxima text-periwinkle-gray text-base tracking-[0.8px] leading-normal hover:text-white transition-colors">FAQ's</Link>
                <a href="#privacy" className="block font-proxima text-periwinkle-gray text-base tracking-[0.8px] leading-normal hover:text-white transition-colors">Privacy</a>
                <a href="#terms" className="block font-proxima text-periwinkle-gray text-base tracking-[0.8px] leading-normal hover:text-white transition-colors">Terms</a>
              </div>
            </div>

            {/* Contact */}
            <div className="min-w-0">
              <h4 className="font-proxima-bold font-bold text-white text-xl tracking-[1px] leading-normal mb-4">
                Contact
              </h4>
              <div className="space-y-2">
                <div className="font-proxima text-periwinkle-gray text-base tracking-[0.8px] leading-normal break-words">
                  <span>Email </span>
                  <a href="mailto:info@metalogix.solutions" className="hover:text-white transition-colors break-all">info@metalogix.solutions</a>
                </div>
                <div className="font-proxima text-periwinkle-gray text-base tracking-[0.8px] leading-normal">
                  <span>Phone </span>
                  <a href="tel:+27606784270" className="hover:text-white transition-colors">+27 60 678 4270</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
